import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getServerSession } from "next-auth";
import { getNextAuthOptions } from "../../api/auth/[...nextauth]";
import { useEffect, useRef, useState } from "react";
import { showError } from "../../../lib/GeneralFunction";
// import { useRouter } from 'next-nprogress-bar';
import { useRouter } from "next/router";
import postData from "../../../lib/Axios";
import RegisterForm from "./form";
import OtpForm from "./otp";

export async function getServerSideProps(context) {
  const sessionData = await getServerSession(context.req, context.res, getNextAuthOptions(context.req, context.res));
  if (sessionData?.user) {
    return {
      redirect: {
        permanent: false,
        destination: "/",
      },
    };
  }

  return {
    props: {},
  };
}

const Register = (props) => {
  const toast = useRef(null);
  const mainContent = useRef(null);

  const [isScrolled, setIsScrolled] = useState(false);

  const [state, setState] = useState({
    isVerified: false,
    values: {
      email: "",
      password: "",
      name: "",
      no_hp: "",
      time_zone: "wib",

      alamat: "",
      otp: "",
    },
    errors: {},
  });

  const setFieldValue = (name, val) => {
    setState((prevState) => ({
      ...prevState,
      values: { ...prevState.values, [name]: val },
      errors: { ...prevState.errors, [name]: "" },
    }));
  };

  const setErrors = (val = {}) => {
    setState((prevState) => ({
      ...prevState,
      errors: val,
    }));
  };

  useEffect(() => {
    const el = mainContent.current;
    if (el) {
      const isScrollable = el.scrollHeight > el.clientHeight;
      setIsScrolled(isScrollable);
    }
  }, []);

  return (
    <div className="w-full h-full">
      <Toast ref={toast} />
      <div className="min-h-screen flex flex-column md:flex-row" style={{ height: '100dvh' }} >


        <div ref={mainContent} className={`w-full md:w-6 p-5 flex align-items-${isScrolled ? 'start' : 'center'} justify-content-center`} style={{ overflowY: 'auto' }}>
          <div className="w-full" style={{ maxWidth: '500px' }}>
            <div className="shadow-3 card border-round-xl">
              <div className="text-center mb-6">
                <div className="flex justify-content-center mb-4">
                  <img
                    src={`/layout/images/godongpng.png`}
                    alt="Register Logo"
                    style={{ height: '60px' }}
                  />
                </div>

              </div>

              <div style={{ border: 'solid 1px rgba(0, 0, 0, 0.13)', width: '100%' }}></div>

              <div className="p-4">
                {state.isVerified ? (
                  <RegisterForm
                    toast={toast}
                    setState={setState}
                    setErrors={setErrors}
                    state={state}
                    setFieldValue={setFieldValue}
                  />
                ) : (
                  <OtpForm
                    toast={toast}
                    setState={setState}
                    setErrors={setErrors}
                    state={state}
                    setFieldValue={setFieldValue}
                  />
                )}
              </div>

              <div className="text-center mt-6">
                <span className="text-600 font-medium line-height-3">
                  © microva.id {new Date().getFullYear()} - All rights reserved
                </span>
                <div className="mt-2 flex justify-content-center gap-3">
                  <a href="#" className="text-600 hover:text-900"><i className="pi pi-globe"></i></a>
                  <a href="#" className="text-600 hover:text-900"><i className="pi pi-instagram"></i></a>
                  {/* <a href="#" className="text-600 hover:text-900"><i className="pi pi-github"></i></a> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden md:flex w-0 md:w-6 shadow-2 bg-blue-800 p-5 flex-column justify-content-between" style={{
          backgroundImage: `url(/layout/images/login-hero.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          width: '100%',
        }}>

          <div>
            <div className="text-green-900 text-3xl font-bold mb-4">app.microva.id</div>
            <p className="text-green-600 line-height-3">
              Selamat datang di marketplace utama aplikasi berbasis SaaS yang dimiliki oleh microva.id
            </p>
          </div>

          <div className="text-green-600">
            <div className="flex align-items-center mb-3">
              <i className="pi pi-shield mr-2" />
              <span>Secure Programs</span>
            </div>
            <div className="flex align-items-center mb-3">
              <i className="pi pi-chart-line mr-2" />
              <span>Real-time Analytics</span>
            </div>
            <div className="flex align-items-center">
              <i className="pi pi-cog mr-2" />
              <span>Centralized Control</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

Register.getLayout = function Register(page) {
  return <>{page}</>;
};

export default Register;
